import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const addPromptQuestion = async (payload) => {
    const formData = new FormData();
    for (const key in payload) {
        formData.append(key, payload[key]);
    }

    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/add_prompt_questions`,
        data: payload,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN,
            "Content-Type": "multipart/form-data"
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const editPromptQuestion = async (payload) => {
    const formData = new FormData();
    for (const key in payload) {
        formData.append(key, payload[key]);
    }

    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/edit_prompt_questions`,
        data: payload,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN,
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};